<template>
	<VueHtml2pdf
		ref="html2Pdf"
		:show-layout="false"
		:float-layout="true"
		:enable-download="false"
		:preview-modal="true"
		:paginate-elements-by-height="1400"
		:filename="filename"
		:pdf-quality="2"
		:manual-pagination="false"
		:html-to-pdf-options="options"
		@beforeDownload="beforeDownload($event)"
	>
		<template slot="pdf-content">
			<v-app>
				<div class="mx-8 mt-8">
					<v-avatar size="48px">
						<img :src="logo"></img>
					</v-avatar>
					<span class="ml-4 text-h4">{{ logoTitle }}</span>

					<h2 class="text-center">{{ title }}</h2>

					<v-row no-gutters>
						<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
							<!-- № {{ id }} -->
						</v-col>
						<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="text-right">
							{{ item.datecreate | formatDateTime }}
						</v-col>
						<v-col cols="12" class="text-right">
							{{ username }}
						</v-col>
					</v-row>
				</div>

				<v-divider class="mx-8"></v-divider>

				<div class="mx-8 my-6">
					<div class="text-subtitle-1 font-weight-bold">Фото ТЗ</div>

					<v-row>
						<v-col v-for="(file, index) in files" :key="index"
							class="d-flex child-flex"
							cols="4"
						>
							<img :src="file.src" :alt="file.alt"></img>
						</v-col>
					</v-row>
				</div>

				<v-divider class="mx-8"></v-divider>

				<div class="mx-8 my-6" v-html="item.content"></div>
			</v-app>
		</template>
	</VueHtml2pdf>
</template>

<script>
import mixin from './mixin/main'
import VueHtml2pdf from 'vue-html2pdf' //https://www.npmjs.com/package/vue-html2pdf

export default {
	mixins: [mixin],
	components: { VueHtml2pdf },
	data: () => ({
		
	}),
	
	computed: {
		files() {
			//console.log(this.$options.name, 'files', 'item', this.item)

			let res = this.item?.files ? this.item?.files.map(file => { 
				return	{
					src: URL.createObjectURL(file),
					/* src: file.src,
					alt: file.name */
				}
			}) : []

			//console.log(this.$options.name, 'files', 'res', res)

			return res
		},
	},
}

</script>